import { BodyDropPivotTarget } from "ag-grid-community";

export interface IDonorWithRemoteRecipient {
    id: number,
    fullName: string,
    donorId: number,
    patientCenter: string,
    patientName: string,
    remoteStatus: number,
    comments: string,
    remoteStatusLastUpdatedDate: string,
    coordinatorId: number,
    remoteStatusDate: string,
    hasMicrositeRecipient: boolean
}